
<template>
  <div class="slide-verify" v-if="visible" @click="close">
    <div class="mask" @click.stop></div>
    <div class="content" @click.stop>
      <div class="captcha-box">
        <div class="images" :style="{ width: width + 'px', height: height + 'px' }">
          <img :src="background" class="bg-img" alt="background" />
          <img
              :src="slider"
              class="slider-img"
              alt="slider"
              :style="{ left: sliderLeft + 'px', top: sliderTop + 'px' }"
          />
        </div>
        <div class="slider-container">
          <div class="slider-mask" :style="{ width: sliderLeft + 'px' }">
            <div class="slider" :style="{ left: sliderLeft + 'px' }" @mousedown="onMouseDown">
              <span class="slider-icon">&rarr;</span>
            </div>
          </div>
          <span class="slider-text" :class="{ 'slider-text-active': isSliderActive }">{{ sliderText }}</span>
        </div>
        <div class="refresh" @click="refresh">
          <span class="refresh-icon">↻</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>import {authApi} from "@/api/auth";

export default {
  name: 'SlideCaptcha',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 350
    },
    height: {
      type: Number,
      default: 220
    }
  },

  data() {
    return {
      background: '',
      slider: '',
      sliderTop: 0,
      sliderLeft: 0,
      captchaId: '',
      isDragging: false,
      startX: 0,
      lastMoveX: 0,
      sliderText: '拖动滑块完成拼图',
      isVerifying: false,
      isSliderActive: false
    }
  },

  methods: {
    async refresh() {
      try {
        // 添加加载状态
        this.sliderText = '加载中...'
        const res = await authApi.captcha();
        // Handle the new Result wrapper
        const data = res.data.data;
        this.background = data.background
        this.slider = data.slider
        this.sliderTop = data.y
        this.captchaId = data.token
        this.sliderLeft = 0
        // 恢复默认提示文字
        setTimeout(() => {
          this.sliderText = '拖动滑块完成拼图'
        }, 300)
      } catch (error) {
        console.error('Failed to load captcha', error)
        this.sliderText = '加载失败，请重试'
        setTimeout(() => {
          this.sliderText = '拖动滑块完成拼图'
        }, 1500)
      }
    },

    onMouseDown(e) {
      this.isDragging = true
      this.isSliderActive = true
      this.startX = e.clientX
      this.lastMoveX = 0

      // 防止默认行为和冒泡
      e.preventDefault()
      e.stopPropagation()

      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('mouseup', this.onMouseUp)
      document.addEventListener('mouseleave', this.onMouseUp)
    },

    onMouseMove(e) {
      if (!this.isDragging) return
      
      // 防止默认行为和冒泡
      e.preventDefault()
      e.stopPropagation()
      
      const moveX = e.clientX - this.startX
      
      // 使用requestAnimationFrame提高流畅度
      if (this.lastMoveX !== moveX) {
        this.lastMoveX = moveX
        requestAnimationFrame(() => {
          // 动态获取滑块宽度，适应响应式设计
          const sliderWidth = window.innerWidth <= 480 ? 44 : window.innerWidth <= 768 ? 48 : 56
          if (moveX < 0) {
            this.sliderLeft = 0
          } else if (moveX > this.width - sliderWidth) {
            this.sliderLeft = this.width - sliderWidth
          } else {
            this.sliderLeft = moveX
          }
        })
      }
    },

    onMouseUp() {
      if (!this.isDragging) return
      this.isDragging = false
      this.isSliderActive = false
      document.removeEventListener('mousemove', this.onMouseMove)
      document.removeEventListener('mouseup', this.onMouseUp)
      document.removeEventListener('mouseleave', this.onMouseUp)

      // 添加验证中状态
      this.isVerifying = true
      this.sliderText = '验证中...'

      // 模拟验证过程，实际项目中可以根据API响应来处理
      setTimeout(() => {
        // Submit verification
        this.$emit('success', {
          captchaId: this.captchaId,
          moveX: this.sliderLeft
        })
        
        // 验证成功动画效果
        this.sliderText = '验证成功！'
        setTimeout(() => {
          this.close()
        }, 800)
      }, 500)
    },

    close() {
      this.$emit('update:visible', false)
    }
  },

  mounted() {
    // 可以在这里调用 refresh 来初始化验证码
    // this.refresh()
  }
}
</script>

<style scoped>
.slide-verify {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
}

.content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  transform: translateY(-55px);
}

.content:hover {
  transform: translateY(-55px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.captcha-box {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.images {
  position: relative;
  background: #f8f9fa;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.05);
}

.bg-img {
  width: 100%;
  height: 100%;
  display: block;
}

.slider-img {
  position: absolute;
  top: 0;
  left: 0;
  height: 50px; /* Fixed in backend */
  width: 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.slider-container {
  position: relative;
  text-align: center;
  width: 100%;
  height: 48px;
  line-height: 48px;
  margin-top: 16px;
  color: #45494c;
  border: 1px solid #e4e7eb;
  border-radius: 24px;
  overflow: hidden;
  background: #f8f9fa;
  transition: all 0.3s ease;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.slider-container:hover {
  border-color: #c3dafe;
  background: #f1f5f9;
}

.slider-mask {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 24px;
  background: linear-gradient(90deg, #3b82f6 0%, #60a5fa 100%);
  transition: width 0.08s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.3);
}

.slider {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 56px;
  height: 56px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #e4e7eb;
  z-index: 10;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  touch-action: none;
  -webkit-tap-highlight-color: transparent;
}

.slider:hover {
  background: white;
  transform: translateY(-50%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: #e4e7eb;
}

.slider:active {
  transform: translateY(-50%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.slider-icon {
  font-size: 20px;
  color: #3b82f6;
}

.slider:hover .slider-icon {
  transform: none;
}

.slider:active .slider-icon {
  transform: none;
}

/* 滑块被拖动时文字变为蓝色 */
.slider:active + .slider-text {
  color: #3b82f6 !important;
  font-weight: 600 !important;
}

/* 滑块被按下时文字变为蓝色 */
.slider:active ~ .slider-text {
  color: #3b82f6 !important;
  font-weight: 600 !important;
}

/* 滑块被激活时文字变为蓝色 */
.slider-text-active {
  color: #3b82f6 !important;
  font-weight: 600 !important;
}

.slider-text {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  position: relative;
  z-index: 5;
}

.slider-container:hover .slider-text {
  color: #64748b;
  font-weight: 500;
}

/* 验证状态样式 */
.slider-text {
  /* 移除过渡效果 */
}

/* 加载状态样式 */
.slider-text:contains('加载中') {
  /* 移除动画效果 */
}

/* 验证成功样式 */
.slider-text:contains('验证成功') {
  color: #10b981;
  font-weight: 600;
  /* 移除动画效果 */
}

/* 加载失败样式 */
.slider-text:contains('加载失败') {
  color: #ef4444;
  /* 移除动画效果 */
}

.refresh {
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
  font-size: 24px;
  z-index: 10;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(2px);
}

.refresh:hover {
  background: rgba(0, 0, 0, 0.3);
  transform: rotate(15deg) scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.refresh:active {
  transform: rotate(30deg) scale(0.95);
}

.refresh-icon {
  transition: transform 0.3s ease;
}

.refresh:hover .refresh-icon {
  transform: rotate(180deg);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content {
    padding: 16px;
    margin: 0 20px;
  }
  
  .captcha-box {
    max-width: 100%;
  }
  
  .slider {
    width: 48px;
    height: 48px;
  }
  
  .slider-icon {
    font-size: 16px;
  }
  
  .slider-container {
    height: 40px;
    line-height: 40px;
  }
  
  .slider-text {
    font-size: 12px;
  }
  
  .refresh {
    width: 32px;
    height: 32px;
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .content {
    padding: 12px;
    margin: 0 16px;
  }
  
  .slider {
    width: 44px;
    height: 44px;
  }
  
  .slider-container {
    height: 36px;
    line-height: 36px;
  }
  
  .slider-text {
    font-size: 11px;
  }
}
</style>